export default "__VITE_ASSET__Bw3_P6aR__"